import { TRootState } from 'Redux/Reducers';

export const getOrganisationInvoiceCount = (state: TRootState) => state.organisationInvoice.maxCount;
